// extracted by mini-css-extract-plugin
export default {"default":"Switch_default__YblKP","small":"Switch_small__72X9+"};